import { useEffect, useState } from 'react';

/**
 * Phát hiện thiết bị mobile theo bề rộng màn hình.
 * Mặc định 900px — khớp với breakpoint mà menu/hamburger mobile xuất hiện.
 */
export default function useIsMobile(maxWidth = 900) {
    const query = `(max-width: ${maxWidth}px)`;
    const [isMobile, setIsMobile] = useState(() =>
        typeof window !== 'undefined' && window.matchMedia ? window.matchMedia(query).matches : false,
    );

    useEffect(() => {
        if (typeof window === 'undefined' || !window.matchMedia) return undefined;
        const mql = window.matchMedia(query);
        const handler = (e) => setIsMobile(e.matches);
        setIsMobile(mql.matches);
        mql.addEventListener('change', handler);
        return () => mql.removeEventListener('change', handler);
    }, [query]);

    return isMobile;
}
